import { Box, Grid, Slide, Typography, useTheme } from "@mui/material"
import { useCallback, useEffect, useState } from "react"
import { AccountType } from "./Components/AccountType";
import { LoginForm } from "./Components/LoginForm";
import { TransitionGroup } from "react-transition-group";
import { useAppDispatch } from "../../Redux/store";
import { setIsLoggedIn } from "../../Redux/slices/GlobalSlice";
import { ForgotPassword } from "./Components/ForgotPassword";
import { EmailSent } from "./Components/EmailSent";
import { ResetPassword } from "./Components/ResetPassword";
import { ProfileType } from "../../Types/General";

export enum ILoginScreen  {
    'account',
    'login',
    'forgot',
    'sent'
}

export const Login = () => {
    /* ******************** Hooks ******************** */
    const dispatch = useAppDispatch();
    dispatch(setIsLoggedIn(false));
    /* ******************** Variables ******************** */
    const [screen, setScreen] = useState<ILoginScreen>(ILoginScreen['account']);
    const [loginType, setLoginType] = useState<ProfileType | undefined>(undefined);
    const getTitle = () => {
        switch(screen) {
            case ILoginScreen['account']:
            case ILoginScreen['login']:
                return 'Log in';
            case ILoginScreen['forgot']:
                return 'Update your password';
            case ILoginScreen['sent']:
                return 'Email sent';
        }

    }
    const getView = () =>{
        switch(screen) {
            case ILoginScreen['account']:
                return <AccountType setLoginType={setLoginType} setScreen={setScreen} />;
            case ILoginScreen['login']:
                return <LoginForm loginType={loginType} setScreen={setScreen} />;
            case ILoginScreen['forgot']:
                return <ForgotPassword loginType={loginType} setScreen={setScreen} />;
            case ILoginScreen['sent']:
                return <EmailSent />;
        }
    }
    /* ******************** Functions ******************** */
    /* ******************** Effects ******************** */
    /* ******************** JSX ******************** */
    return (
        <Grid
            bgcolor={'green.50'}
            width={"100%"}
            height={"100%"}
            overflow={"hidden"}
            display={"grid"}
            gridTemplateRows={"repeat(2, min-content)"}
            justifyItems={"center"}
            paddingY={14}
        >    
            <Grid item  display={"flex"} flexDirection={"column"} justifyContent={"center"} alignItems={"center"}>
                <Typography variant="lora-display-small" marginBottom={"16px"}>{getTitle()}</Typography>
            </Grid>
            <Grid 
                item 
                xs="auto" 
            > 
                <Box                               
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "flex-start",
                        alignItems: "center",
                        height: "fit-content"
                    }}
                >        
                    {getView()}
                </Box>           
            </Grid>
        </Grid>
    )
}